import {clientsClaim as workbox_core_clientsClaim} from '/var/www/html/wp-content/themes/pe-theme/library/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/var/www/html/wp-content/themes/pe-theme/library/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "library/build/appassets/fonts/.gitkeep",
    "revision": "d41d8cd98f00b204e9800998ecf8427e"
  },
  {
    "url": "library/build/appassets/fonts/Quentin.otf",
    "revision": "328fdcdf83ac1d612edc70ebd41c861f"
  },
  {
    "url": "library/build/appassets/icons.919274e3.svg",
    "revision": "19f42441bda5689a96546e646947cd7d"
  },
  {
    "url": "library/build/appassets/img/cta-background.svg",
    "revision": "3f60579a7426ac28003044bc7de1df83"
  },
  {
    "url": "library/build/appassets/img/cta-small.svg",
    "revision": "acbe0a07f3062e4a6d5edd834e642e17"
  },
  {
    "url": "library/build/appassets/img/hero-decoration.svg",
    "revision": "cab53da8dbcee41c17e869bb12fc260e"
  },
  {
    "url": "library/build/appassets/img/pe-logo.svg",
    "revision": "92c628752526c2157a169226e806b8b3"
  },
  {
    "url": "library/build/appassets/img/placeholder.svg",
    "revision": "707ba9752c6a2a3217003d9b2525f54d"
  },
  {
    "url": "library/build/appmain.6bf2e11b.css",
    "revision": null
  },
  {
    "url": "library/build/appmain.aa616447.js",
    "revision": null
  },
  {
    "url": "library/build/appmain.aa616447.js.LICENSE.txt",
    "revision": "131b7cd5bdb33d1246f3112e2a6ff43f"
  }
], {});








